import script from "./ResultsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsHeader.vue?vue&type=script&setup=true&lang=js"

import "./ResultsHeader.vue?vue&type=style&index=0&id=73c602b0&lang=scss"

const __exports__ = script;

export default __exports__